<div class="tw-flex tw-h-full tw-w-full">
    <app-settings-alvolo-options-list (optionEmitter)="getOption($event)"></app-settings-alvolo-options-list>
    <app-settings-alvolo-content class="tw-w-full tw-h-full" [option]="optionSelected"></app-settings-alvolo-content>
</div>
